"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyCoverageCatalogResume = void 0;
function makeEmptyCoverageCatalogResume() {
    return {
        code: '',
        type: '',
        applyDeductible: false,
    };
}
exports.makeEmptyCoverageCatalogResume = makeEmptyCoverageCatalogResume;
//# sourceMappingURL=CoverageCatalogResume.js.map